<ui-modal
  class="rates-ladder-modal"
  [isOpened]="isModalOpened"
  modalTitle="Rates Ladder"
  size="lg"
  (isOpenedChange)="modalChanged($event)"
>
  <div class="outer">
    @if (legIndices.length === 0) {
      <div class="row-spread main-margin">
        There are no eligible legs for this strategy.
      </div>
    } @else {
      <form [formGroup]="form" autocomplete="off" clrForm>
        <div class="row-spread main-margin">
          <clr-select-container>
            <label>Leg&nbsp;Index</label>
            <select clrSelect name="options" formControlName="legIndex">
              <option [value]="item" *ngFor="let item of legIndices">
                {{ item }}
              </option>
            </select>
            <clr-control-helper>&nbsp;</clr-control-helper>
          </clr-select-container>
          <clr-input-container>
            <label>Min&nbsp;(required)</label>
            <input clrInput formControlName="minBumpAmount" />
            <div clrInputSuffix>bps</div>
            <clr-control-helper> Min bump. Must be &lt;0 </clr-control-helper>
          </clr-input-container>
          <clr-input-container>
            <label>Max&nbsp;(required)</label>
            <input clrInput formControlName="maxBumpAmount" />
            <div clrInputSuffix>bps</div>
            <clr-control-helper> Max bump. Must be >0 </clr-control-helper>
          </clr-input-container>
          <clr-input-container>
            <label>Step&nbsp;(optional)</label>
            <input clrInput formControlName="step" />
            <clr-control-helper> Step incr. Must be >0 </clr-control-helper>
            <div clrInputSuffix>bps</div>
          </clr-input-container>
        </div>
        <div class="row-spread main-margin">
          <div class="buttons">
            <button
              type="button"
              (click)="calculate()"
              [disabled]="!form?.valid || status === 'calculating'"
              class="ui-button primary"
            >
              <div
                class="modal-footer__calculate-button__spinner-container"
                *ngIf="status === 'calculating'; else allowCalculating"
              >
                <span class="spinner spinner-sm"></span>
              </div>
              <ng-template #allowCalculating>Calculate</ng-template>
            </button>
            <button
              type="button"
              (click)="cancel()"
              [disabled]="status !== 'calculating'"
              class="ui-button primary"
            >
              Cancel
            </button>
          </div>
        </div>

        <div class="row-spread main-margin" *ngIf="status === 'calculating'">
          Calculation may take a while. {{ message }}
        </div>

        @if (status === 'finished') {
          <div class="column-left main-margin">
            <label>Legs</label>
            <div class="row-left">
              <div
                formArrayName="legsFormArray"
                *ngFor="let leg of selectedLegComponents; let i = index"
              >
                <clr-toggle-container>
                  <clr-toggle-wrapper>
                    <input
                      type="checkbox"
                      (change)="legToggleChange()"
                      clrToggle
                      [formControl]="legsFormArrayControls[i]"
                    />
                    <label>Leg {{ i + 1 }}</label>
                  </clr-toggle-wrapper>
                </clr-toggle-container>
              </div>
            </div>
          </div>
          @if (selectedLegComponents.length > 2) {
            <div class="column-left main-margin">
              <div class="row-spread">
                <button
                  class="ui-button primary"
                  type="button"
                  (click)="toggleLegs(true)"
                >
                  Enable all legs
                </button>
                <button
                  class="ui-button primary"
                  type="button"
                  (click)="toggleLegs(false)"
                >
                  Disable all legs
                </button>
              </div>
            </div>
          }
        }
      </form>

      @if (showChart) {
        <div class="row-spread main-margin">
          <ag-charts
            style="width: 100%; height: 20rem"
            [options]="chartOptions"
          >
          </ag-charts>
        </div>
        <div class="row-spread main-margin">
          <div></div>
          <button class="ui-button primary" type="button" (click)="copy()">
            {{ copyState }}
          </button>
        </div>
      }
    }
  </div>
</ui-modal>
